import { Skeleton } from "@mui/material";
import ComparePointClouds from "containers/ComparePointClouds";
import PointCloudViewerContent from "containers/ComparePointClouds/components/PointCloudViewerContent";
import ComparePointCloudVirtualTour from "containers/ComparePointCloudVirtualTour";
import CompareVirtualTourAPS from "containers/CompareVirtualTourAPS";
import CompareVirtualTours from "containers/CompareVirtualTours";
import GSplatViewer from "containers/GaussianSplatViewer/GSplatViewer";
import PointCloudViewer from "containers/PointCloudViewer";
import VirtualTourViewer from "containers/VirtualTourViewer/VirtualTourViewer";
import { useLoading } from "contexts/LoadingContext";
import { Suspense, lazy } from "react";
import { useSearchParams } from "react-router-dom";
import { Bounce, toast } from "react-toastify";

// Lazy load APS viewer to improve initial load performance
const ApsViewer = lazy(() => import("../../pages/ApsViewerPage/ApsViewerPage"));

const ErrorMessage = (message: string, message2?: string) => {
  return toast.error(message + (message2 ? `\n${message2}` : ""), {
        position: "bottom-left",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
        transition: Bounce,
      });
};
const Viewer = () => {
  const [queryParams] = useSearchParams();
  const mode = queryParams.get("mode");
  const type = queryParams.get("type");
  const secondType = queryParams.get("secondType");
  const { ptcldOutputId1, vtourOutputId1, ptcldOutputId2, vtourOutputId2, gsplatOutputId1 } =
    useLoading();
  let content;
  switch (mode) {
    case "uniscan":
      if (type === "vtour") {
        if (vtourOutputId1) {
          content = <VirtualTourViewer mode={mode} key={vtourOutputId1} />;
        } else {
          ErrorMessage("No virtual tour output found");
          content = <Skeleton height="100%" />;
        }
      } else if (type === "aps") {
        // APS Viewer case
        content = <ApsViewer />;
      } else if (type === "ptcld") {
        if (ptcldOutputId1) {
          content = <PointCloudViewer key={ptcldOutputId1} />;
        } else {
          ErrorMessage("No point cloud output found");
          content = <Skeleton height="100%" />;
        }
      } else if (type === "gsplat") {
        // if (gsplatOutputId1) {
          content = (
            <GSplatViewer
              sourceType={"preimage-output"}
              sourceId={gsplatOutputId1}
               key={gsplatOutputId1}
            />
          )
        // } else {
        //   ErrorMessage("No Gaussian splat output found");
        //   content = <Skeleton height="100%" />;
        // }
      }
      break;

    case "biscan":
      if (type === "vtour") {
        if (vtourOutputId1 || vtourOutputId2) {
          content = <CompareVirtualTours key={`${vtourOutputId1}-${vtourOutputId2}`} />;
        } else {
          ErrorMessage("Missing virtual tour outputs for comparison");
          content = <Skeleton height="100%" />;
        }
      } else {
        if (ptcldOutputId1 || ptcldOutputId2) {
          content = <ComparePointClouds key={`${ptcldOutputId1}-${ptcldOutputId2}`} />;
        } else {
          ErrorMessage("Missing point cloud outputs for comparison");
          content = <Skeleton height="100%" />;
        }
      }
      break;

    case "uniscan-compare":
      if (secondType === "aps") {
        if (vtourOutputId1) {
          content = <CompareVirtualTourAPS key={`${vtourOutputId1}-aps`} />;
        } else {
          ErrorMessage("Missing outputs for virtual tour/APS comparison");
          content = <Skeleton height="100%" />;
        }
      } else if (ptcldOutputId1 && ptcldOutputId2 && secondType === "ifc") {
        content = <ComparePointClouds key={`${ptcldOutputId1}-ifc`} />;
      } else if (vtourOutputId1 || ptcldOutputId2) {
        content = <ComparePointCloudVirtualTour key={`${vtourOutputId1}-${ptcldOutputId2}`} />;
      } else {
        ErrorMessage("Missing outputs for point cloud/virtual tour comparison");
        content = <Skeleton height="100%" />;
      }
      break;

    default:
      content = <Suspense fallback={<Skeleton height="100%" />}></Suspense>;
  }

  return content;
};

export default Viewer;
